<template>
  <div>
    <v-alert type="error">
      当前页面被标记为<b>开发中</b>，暂时无法实现功能，敬请期待。
    </v-alert>
    <h2>
      Nyan Online
      <sup>
        <v-chip class="ma-2" color="info" small>BETA</v-chip>
      </sup>
    </h2>
    <v-alert color="primary" dark v-if="nyanLoad === 0">
      <v-progress-circular indeterminate color="white" style="margin-right:10px;"></v-progress-circular>
      <span>正在尝试连接NyanRX......</span>
    </v-alert>
    <div v-else-if="nyanLoad === 1">
      <v-alert type="info" dismissible>NyanUX-Online is currently a beta version, and the priority of update and repair is lower than NyanUX. It is recommended to download NyanUX, this can be offline.</v-alert>
      <!-- <nyanWindow></nyanWindow> -->
    </div>
    <!-- <v-alert type="error" v-else>
      <span>尝试连接Nyan启动器失败，请根据下方可能的错误情况进行排查。</span>
      <ul>
        <li>
          未下载Nyan启动器。
          <a href style="color:white;">点击下载</a>
        </li>
        <li>未设置启动协议。</li>
        <li>请确定是Chrome/Firefox/Microsoft EDGE或其他Chromium内核的浏览器</li>
        <li>
          <v-row>
            <v-col>
              <span>已排除上述错误，并已手动启动Nyan启动器，请尝试点击按钮进行手动连接。</span>
            </v-col>
            <v-col>
              <v-btn depressed small>重新连接</v-btn>
            </v-col>
          </v-row>
        </li>
      </ul>
    </v-alert> -->
    <v-alert type="warning" v-else>
      <span>尝试连接Nyan启动器失败，当前并未开放该权限。</span> 
    </v-alert>
    <h2>库</h2>
    <v-row>
      <gameBox
        v-for="(t, i) in gameList"
        :key="`_USER-MYGAMECARD-${i}`"
        src="https://odrive.h-disk.net/images/mcbg1.jpg"
        :title="`Minecraft ${t.v}`"
        :cols="3"
        :cloud="t.cloud"
      ></gameBox>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameList: [
        {
          v: "1.7.10",
          cloud: false
        },
        {
          v: "1.10.1",
          cloud: true
        },
        {
          v: "1.12",
          cloud: false
        },
        {
          v: "1.12.4",
          cloud: false
        },
        {
          v: "1.13.1",
          cloud: true
        }
      ],
      nyanLoad: -1
    };
  },
  components: {
    gameBox: () => import("../../components/userGameCard"),
    // nyanWindow: () => import("../../components/nyan-window")
  }
};
</script>